<template>
    <div class="">
        <div class="header-container">
            <div class="nav-wrapper">
                <div v-for="(item, key) in navList" :key="key" @click="handleNav(item.id)"
                    :class="activeNav == item.id ? 'nav-item-active' : 'nav-item'">
                    {{ item.label }}
                    <span v-for="(numItem, numKey) in navSortNum" :key="'num' + numKey">
                        <span v-if="item.id == numKey">({{ numItem }})</span>
                    </span>
                </div>
            </div>
            <div class="search-container">
                <div class="page-mode-input-wrapper">
                    <div class="page-mode-input">
                        <el-input v-model="searchVal" placeholder="请输入搜索内容"></el-input>
                    </div>
                    <div class="input-btn" @click="handleSearch">
                        <i class="el-icon-search input-btn-icon"></i>
                        <span class="input-btn-label">搜索</span>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="tableData.length > 0" class="plan-wrapper">
            <div v-for="(item, key) in tableData" :key="key" class="plan-content-wrapper">
                <div class="plan-content-header-wrapper">
                    <div class="plan-content-title-wrapper">
                        <div v-if="item.status == 0" class="plan-content-title-btn">全部</div>
                        <div v-if="item.status == 1" class="plan-content-title-btn btn-status-0">待开始</div>
                        <div v-if="item.status == 2" class="plan-content-title-btn btn-status-1">进行中</div>
                        <div v-if="item.status == 3" class="plan-content-title-btn btn-status-2">已完成</div>
                        <div v-if="item.status == 4" class="plan-content-title-btn btn-status-3">未完成</div>
                        <div class="plan-content-title">{{ item.planName }}</div>
                    </div>
                </div>
                <div class="plan-table-wrapper">
                    <div class="plan-table-content">
                        <div class="plan-table-item">
                            开始：{{ item.planStartTime }}
                        </div>
                        <div class="plan-table-item">
                            结束：{{ item.planEndTime }}
                        </div>
                    </div>
                    <div class="plan-table-btn-wrapper">
                        <div v-if="item.status == 3" class="plan-table-btn" @click="viewCertificate(item)">
                            查看证书
                        </div>
                        <!-- <div :class="`plan-table-btn ${item.status == 1 ? 'not-into' : ''} ${'disabled': isshow&&isshow.expire == 1 }` "
                            @click="handlePalnDetail(item)">
                            查看计划
                        </div> -->
                        <div :class="['plan-table-btn',
                            { 'not-into': item.status == 1 },
                            { 'disabled': isshow && isshow.expire == 1 }]" @click="handlePalnDetail(item)">
                            查看计划
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="no-data-wrapper">
            <img src="@/assets/img/nodata.png" alt="" class="no-data-img">
            <div class="no-data-label">暂无管理计划！</div>
        </div>
        <div v-if="tableData.length > 0 && currentPage < totalPages" class="view-more-btn" @click="viewMore">查看更多</div>

        <el-dialog title="" :show-close="true" width="500px" top="100px" :visible.sync="certificateShow"
            class="dialog-container">
            <div class="dialog-content-wrapper">
                <div class="dialog-content">
                    <div class="card-container">
                        <div class="card-wrapper">
                            <div class="card-title">学习计划完成证书</div>
                            <div class="card-label">{{ certificate.planName }}</div>
                            <div class="card-date">{{ certificate.finishedTime }}</div>
                            <div class="card-img-wrapper">
                                <img src="@/assets/img/basic-info.png" alt="" class="card-img">
                            </div>
                            <div class="card-name">{{ certificate.userName }}</div>
                            <div class="card-comp">{{ certificate.companyName }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { myPlanList, myPlanSortNum, updateMyPlanStatus, myPlanCertificate } from '@/api/index.js';
export default {
    name: '',
    components: {

    },
    data() {
        return {
            isshow: null,
            dept: '',
            token: '',
            searchVal: '',
            activeNav: 0,
            navList: [
                {
                    id: 0,
                    label: '全部'
                },
                {
                    id: 1,
                    label: '待开始'
                },
                {
                    id: 2,
                    label: '进行中'
                },
                {
                    id: 3,
                    label: '已完成'
                },
                {
                    id: 4,
                    label: '到期未完成'
                }
            ],
            navSortNum: {},
            tableData: [],
            currentPage: 1,
            totalPages: 1,
            certificateShow: false,
            certificate: {}
        }
    },
    mounted() {
        this.dept = window.localStorage.getItem('dept');
        this.token = window.localStorage.getItem('token');
        this.isshow = JSON.parse(window.localStorage.getItem('gqxx'))
        this.getTableData();
        this.getMySortNum();
    },
    methods: {
        handleNav(id) {
            this.currentPage = 1;
            this.tableData = [];
            this.activeNav = id;
            this.getTableData();
        },
        getTableData() {
            myPlanList({
                "deptId": '',
                "keyword": this.searchVal,
                "pageNum": this.currentPage,
                "pageSize": 10000,
                "status": this.activeNav,//0:全部，1:待开始，2：进行中，3：已完成，4：到期未完成
                "userId": 0
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data.list;
                    var lastData = this.tableData;
                    this.tableData = lastData.concat(data);
                    this.totalPages = res.data.totalPages;
                }
                return;
            }).catch(err => {
                //  console.log(err);
            });
            // updateMyPlanStatus({},{
            //         Authorization:this.token,
            //         DeptId:this.dept
            //     }).then(res => {
            //         myPlanList({
            //             "deptId": '',
            //             "keyword": this.searchVal,
            //             "pageNum": this.currentPage,
            //             "pageSize": 10000,
            //             "status": this.activeNav,//0:全部，1:待开始，2：进行中，3：已完成，4：到期未完成
            //             "userId": 0
            //         },{
            //             Authorization:this.token,
            //             DeptId:this.dept
            //         }).then(res => {
            //             if(res.code==200){
            //                 var data=res.data.list;
            //                 var lastData=this.tableData;
            //                 this.tableData=lastData.concat(data);
            //                 this.totalPages=res.data.totalPages;
            //             }
            //             return;
            //         }).catch(err => {
            //           //  console.log(err);
            //         });
            // }).catch(err => {
            //   //  console.log(err);
            // });

        },
        handleSearch() {
            this.currentPage = 1;
            this.tableData = [];
            this.getTableData();
        },
        getMySortNum() {
            myPlanSortNum({}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.navSortNum = res.data;
                }
                return;
            }).catch(err => {
                //  console.log(err);
            });
        },
        viewMore() {
            var currentPage = this.currentPage;
            if (currentPage < this.totalPages) {
                this.currentPage = currentPage + 1;
                this.getMemberList();
            } else {
                this.$message({
                    message: '没有更多了',
                    type: 'warning'
                });
            }
        },
        handlePalnDetail(row) {
            this.$router.push(`/planDetail/edit/${row.planId}`);
        },
        viewCertificate(row) {
            myPlanCertificate(row.planId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.certificate = res.data;
                    this.certificateShow = true;
                }
                return;
            }).catch(err => {
                //  console.log(err);
            });
        }
    }
}
</script>

<style scoped>
.header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.search-container {
    display: flex;
    align-items: center;
}

.nav-wrapper {
    display: flex;
}

.nav-item-active {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #606A74;
    margin-right: 30px;
    position: relative;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    cursor: pointer;
    line-height: 22px;
}

.nav-item {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606A74;
    margin-right: 30px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    line-height: 22px;
}

.nav-item:hover {
    cursor: pointer;
    color: #000000;
}

.page-mode-input-wrapper {
    display: flex;
    width: 425px;
}

.page-mode-input>>>.el-input__inner {
    width: 350px !important;
    height: 38px !important;
    border-radius: 6px 0px 0px 6px !important;
    border: 1px solid #6D94FF !important;
    border-right: 0px !important;
}

.input-btn {
    width: 75px;
    height: 38px;
    background: #6D94FF;
    border-radius: 0px 6px 6px 0px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.input-btn:hover {
    cursor: pointer;
    opacity: 0.8;
}

.input-btn-icon {
    font-size: 13px;
}

.input-btn-label {
    margin-left: 5px;
}

.plan-wrapper {
    margin-top: 20px;
    min-height: 600px;
}

.plan-header-title-wrapper {
    display: flex;
    align-items: center;
}

.plan-header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 36px;
    padding-bottom: 10px;
}

.header-img {
    width: 30px;
    height: 30px;
}

.plan-header-title {
    margin-left: 17px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #303B45;
}

.plan-header-btn-wrapper {
    display: flex;
    margin-right: 15px;
}

.header-btn-img {
    width: 20px;
    height: 20px;
    cursor: pointer;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.plan-content-wrapper {
    height: 164px;
    border-bottom: 1px solid #F0F0F0;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.plan-content-header-wrapper {
    display: flex;
    justify-content: space-between;
    padding-top: 28px;
}

.plan-content-title-wrapper {
    display: flex;
    margin-left: 15px;
    align-items: center;
}

.plan-content-title-btn {
    width: 72px;
    height: 26px;
    border-radius: 6px;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 12px;
}

.btn-status-0 {
    background: #9B9FAA;
}

.btn-status-1 {
    background: #FF9645;
}

.btn-status-2 {
    background: #3E63EE;
}

.btn-status-3 {
    background: #F56C6C;
}

.plan-content-title {
    height: 30px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
}

.plan-content-header-delete-wrapper {
    margin-right: 15px;
}

.plan-table-wrapper {
    display: flex;
    justify-content: space-between;
}

.plan-table-content {
    margin-left: 15px;
    margin-top: 15px;
}

.plan-table-item {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #848F9A;
    margin-top: 5px;
}

.plan-table-btn-wrapper {
    margin-right: 15px;
    display: flex;
}

.plan-table-btn-wrapper .not-into {
    pointer-events: none;
    color: #c0c4cc;
    border-color: #c0c4cc;
}

.plan-table-btn {
    margin-left: 20px;
    width: 108px;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #3E63EE;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #3E63EE;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.plan-table-btn:hover {
    cursor: pointer;
    background: #3E63EE;
    color: #fff;
}

.view-more-btn {
    width: 122px;
    height: 34px;
    border-radius: 20px;
    border: 1px solid #F69264;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #F69568;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    margin-top: 50px;
    margin-bottom: 20px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.view-more-btn:hover {
    cursor: pointer;
    background: #F69264;
    color: #fff;
}

.no-data-wrapper {
    min-height: 600px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.no-data-label {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666;
    margin-top: 20px;
}

.card-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.card-wrapper {
    width: 326px;
    height: 434px;
    background: rgb(255, 250, 241);
    border-radius: 8px;
    border: 1px solid #EAEAEA;
}

.card-title {
    font-size: 24px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #585858;
    text-align: center;
    margin-top: 45px;
}

.card-label {
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    text-align: center;
    margin-top: 27px;
}

.card-img-wrapper {
    text-align: center;
    margin-top: 27px;
}

.card-img {
    width: 160px;
    height: 115px;
}

.card-date {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #585858;
    margin-top: 9px;
    text-align: center;
}

.card-name {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #171718;
    text-align: center;
    margin-top: 3px;
}

.card-comp {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #585858;
    text-align: center;
    margin-top: 30px;
}

.dialog-container>>>.el-dialog,
.el-pager li {
    background: rgba(0, 0, 0, 0) !important;
    box-shadow: 0 0px 0px rgb(0 0 0 / 0%) !important;
}

.dialog-container>>>.el-dialog__headerbtn {
    font-size: 24px !important;
}

.dialog-container>>>.el-dialog__headerbtn .el-dialog__close {
    color: #fff !important;
}

.disabled {
    border: 1px solid #f0f0f0 !important;
    pointer-events: none !important;
    /* 阻止鼠标事件 */
    cursor: no-drop !important;
    /* 鼠标变为禁止标志 */
    background-color: #f0f0f0 !important;
    /* 浅灰色背景 */
    color: #a9a9a9 !important;
    /* 深灰色文本 */
}
</style>

